// src/services/axiosConfig.js
import axios from 'axios';

const configuredAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://backend-0aol.onrender.com/api',
  timeout: 100000
});

// Interceptor para adicionar o token de autenticação em cada requisição
configuredAxios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Lógica para converter objetos com arquivos para FormData automaticamente
  if (config.data && typeof config.data === 'object') {
    if (!(config.data instanceof FormData) && Object.values(config.data).some(val => val instanceof File || val instanceof Blob)) {
      console.log('[axiosConfig] Converting to FormData:', config.url);
      const formData = new FormData();
      Object.entries(config.data).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });
      config.data = formData;
    } else if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
  }
  
  console.log('[axiosConfig] Request:', config.method.toUpperCase(), config.url);
  return config;
}, error => Promise.reject(error));

// Interceptor para tratar respostas e erros globalmente
configuredAxios.interceptors.response.use(
  response => {
    console.log('[axiosConfig] Response Success:', response.config.method.toUpperCase(), response.config.url, response.status);
    return response;
  },
  error => {
    console.error('[axiosConfig] Response Error Raw:', error);
    if (error.response) {
        console.error('[axiosConfig] Response Error Details:', error.response.config.method.toUpperCase(), error.response.config.url, error.response.status, error.response.data);
    }

    // --- LÓGICA AJUSTADA ---
    // A lógica de logout só deve ser acionada para erros 401 em rotas protegidas,
    // e NÃO na própria tentativa de login.
    if (error.response?.status === 401 && !error.config.url.endsWith('/auth/login')) {
      console.warn('[axiosConfig] Intercepted 401 on a protected route. Clearing token and redirecting to login.');
      
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      if (window.location.pathname !== '/login') {
        const redirectReason = `reason=session_expired`;
        const returnTo = `returnTo=${encodeURIComponent(window.location.pathname + window.location.search)}`;
        window.location.href = `/login?${redirectReason}&${returnTo}`;
      }
       
      // Para a propagação do erro, pois já estamos tratando com um redirecionamento.
      return Promise.reject(new Error("Sessão inválida ou expirada. Redirecionando para o login."));
    }

    // Formata o erro para ser consistente e o repassa para o catch do serviço (ex: authService).
    // Isso garante que a mensagem do backend chegue ao componente.
    const processedError = error.response?.data || {
      success: false,
      message: error.message || 'Erro de comunicação com o servidor.',
      status: error.response?.status || 500,
      ...(typeof error.response?.data === 'object' ? error.response.data : {} )
    };

    if (!processedError.message && error.response?.data?.error) {
        processedError.message = error.response.data.error;
    }

    // Rejeita a promise com o erro processado para que o 'catch' no local da chamada possa tratá-lo.
    return Promise.reject(processedError);
  }
);

export { configuredAxios };
export default configuredAxios;